import AgoraRTC from "agora-rtc-sdk";
import { mapState } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      videos: [],
      audios: [],
      resolutions: [
        { name: "default", value: "default" },
        { name: "480p", value: "480p" },
        { name: "720p", value: "720p" },
        { name: "1080p", value: "1080p" }
      ],
      rtc: {
        client: null,
        joined: false,
        published: false,
        localStream: null,
        // remoteStreams: [],
        remoteStreams: {
          // 1: {
          //   video: true,
          //   audio: true,
          //   stream: {
          //     getId() {
          //       return 1;
          //     }
          //   }
          // },
          // 2: {
          //   video: true,
          //   audio: false,
          //   stream: {
          //     getId() {
          //       return 2;
          //     }
          //   }
          // },
          // 3: {
          //   video: true,
          //   audio: false,
          //   stream: {
          //     getId() {
          //       return 3;
          //     }
          //   }
          // },
          // 4: {
          //   video: true,
          //   audio: false,
          //   stream: {
          //     getId() {
          //       return 4;
          //     }
          //   }
          // },
          // 5: {
          //   video: true,
          //   audio: false,
          //   stream: {
          //     getId() {
          //       return 5;
          //     }
          //   }
          // },
          // 6: {
          //   video: true,
          //   audio: false,
          //   stream: {
          //     getId() {
          //       return 6;
          //     }
          //   }
          // }
        },
        params: {
          // channel: "", this.gameId
          // uid: "222", this.user.id
          appID: "d8d6d745aac54201931adac8c1472017",
          agoraToken: "",
          cameraId: "",
          microphoneId: "",
          cameraResolution: "default",
          mode: "live",
          codec: "h264",
          audio: true,
          video: true
        }
      }
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    remoteStreamKeys() {
      return Object.keys(this.rtc.remoteStreams);
    },
    remoteStreamLeftKeys() {
      // 1 is the local player
      let leftSide = this.playersOnEachSide - 1;
      return this.remoteStreamKeys.slice(0, leftSide);
    },
    remoteStreamRightKeys() {
      return this.remoteStreamKeys.slice(this.playersOnEachSide - 1);
    },
    playersOnEachSide() {
      let totalPlayers = Object.keys(this.rtc.remoteStreams).length + 1;
      if (totalPlayers % 2 == 0) {
        return totalPlayers / 2;
      }
      return parseInt(totalPlayers / 2 + 1);
    },
    videoGridWidth() {
      return this.window.width * 0.3;
    },
    videoGridHeight() {
      return (this.window.height - 65) * 0.9;
    },
    videoWidth() {
      let possibleVideoHeight = (this.videoGridWidth / 4) * 3;
      if (this.videoGridHeight < possibleVideoHeight * this.playersOnEachSide) {
        let heightPerVideo =
          (this.videoGridHeight - 10 * (this.playersOnEachSide - 1)) /
          this.playersOnEachSide;
        return (heightPerVideo / 3) * 4;
      } else {
        return this.videoGridWidth;
      }
    },
    videoHeight() {
      return (this.videoWidth / 4) * 3;
    },
    videoGridStyling() {
      let height = this.videoGridHeight;
      let marginTop = 65 + (this.videoGridHeight * 0.1) / 2;
      let width = this.videoGridWidth;
      return `position:absolute;top:0;height:${height}px;width:${width}px;margin-top:${marginTop}px`;
    }
  },
  methods: {
    getAgoraToken() {
      let url = `https://hv03w13bk1.execute-api.us-west-1.amazonaws.com/stage/agoraToken/${this.gameId}?diu=${this.user.id}`;
      // let url = ``;
      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then(({ data }) => {
            this.rtc.params.agoraToken = data.token;
            //   const data = {
            //     token:
            //       "006d8d6d745aac54201931adac8c1472017IADg3oI53CNozlBW8beJE6zAwgERbhl/UN6JOie8T91p+cWFcMYNvtUaIgAi3q2fHL2RXgQAAQCseZBeAgCseZBeAwCseZBeBACseZBe"
            //   };
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getDevices() {
      AgoraRTC.getDevices(items => {
        this.videos = items
          .filter(item => "videoinput" == item.kind)
          .map((item, index) => {
            const { label, deviceId: value, kind } = item;
            let name = label ? label : `camera-${index + 1}`;
            return { name, value, kind };
          });
        this.audios = items
          .filter(item => "audioinput" == item.kind)
          .map((item, index) => {
            const { label, deviceId: value, kind } = item;
            let name = label ? label : `microphone-${index + 1}`;
            return { name, value, kind };
          });
        // make selectable
        this.rtc.params.microphoneId = this.audios[0].value;
        this.rtc.params.cameraId = this.videos[0].value;
      });
    },
    handleFailCallback(err) {
      console.log("error: ", err);
    },
    publish() {
      const { rtc } = this;
      if (!rtc.client) {
        alert("Please Join Room First");
        return;
      }
      if (rtc.published) {
        alert("Your already published");
        return;
      }
      // publish localStream
      let oldState = rtc.published;
      rtc.client.publish(rtc.localStream, err => {
        this.rtc.published = oldState;
        console.log("publish failed: ", err);
      });
      this.rtc.published = true;
    },
    unpublish() {
      const { rtc } = this;
      if (!rtc.client) {
        alert("Please Join Room First");
        return;
      }
      if (!rtc.published) {
        alert("Your didn't publish");
        return;
      }
      let oldState = rtc.published;
      rtc.client.unpublish(rtc.localStream, err => {
        this.rtc.published = oldState;
        console.log(`unpublish failed: ${err}`);
        alert("unpublish failed");
      });
      this.rtc.published = false;
    },
    clientJoinCallback(streamID) {
      console.log(`join channel: ${this.gameId} success, uid: ${streamID}`);
      this.rtc.joined = true;
      const { microphoneId, cameraId, audio, video } = this.rtc.params;
      // create local stream
      this.rtc.localStream = AgoraRTC.createStream({
        streamID,
        audio,
        video,
        screen: false,
        microphoneId,
        cameraId
      });
      this.rtc.localStream.init(() => {
        console.log("init local stream success");
        this.rtc.localStream.play("local_stream");
        // publish local stream
        this.publish();
      }, this.handleFailCallback);
    },
    join() {
      const {
        clientJoinCallback,
        handleFailCallback,
        rtc,
        peerLeave,
        streamAdded,
        streamSubscribed,
        streamRemoved,
        muteVideo,
        unmuteVideo,
        muteAudio,
        unmuteAudio
      } = this;
      const { mode, codec, appID, agoraToken } = rtc.params;
      const uid = this.user.id;
      const channel = this.gameId;
      if (rtc.joined) {
        alert("you already joined");
        return;
      }
      this.rtc.client = AgoraRTC.createClient({ mode, codec });
      const { client } = this.rtc;

      client.init(
        appID,
        () => console.log("video client initialed"),
        handleFailCallback
      );

      client.join(
        agoraToken,
        channel,
        uid,
        clientJoinCallback,
        handleFailCallback
      );
      // Occurs when an error message is reported and requires error handling.
      client.on("error", handleFailCallback);
      // Occurs when the local stream is published.
      client.on("stream-published", evt =>
        console.log("stream-published: ", evt)
      );
      // Occurs when the peer user leaves the channel; for example, the peer user calls Client.leave.
      client.on("peer-leave", peerLeave);
      // Occurs when the remote stream is added.
      client.on("stream-added", streamAdded);
      // Occurs when a user subscribes to a remote stream.
      client.on("stream-subscribed", streamSubscribed);
      // Occurs when the remote stream is removed; for example, a peer user calls Client.unpublish.
      client.on("stream-removed", streamRemoved);
      client.on("mute-video", muteVideo);
      client.on("unmute-video", unmuteVideo);
      client.on("mute-audio", muteAudio);
      client.on("unmute-audio", unmuteAudio);
      // Occrus when token privileages will expire
      client.on("onTokenPrivilegeWillExpire", () => {
        // After requesting a new token
        // client.renewToken(token);
        console.log("onTokenPrivilegeWillExpire");
      });
      // Occrus when token privileages did expire
      client.on("onTokenPrivilegeDidExpire", () => {
        // After requesting a new token
        // client.renewToken(token);
        console.log("onTokenPrivilegeDidExpire");
      });
    },
    muteAudio(evt) {
      let id = evt.uid;
      if (this.rtc.remoteStreams[id]) {
        this.$set(this.rtc.remoteStreams[id], "audio", false);
      }
    },
    unmuteAudio(evt) {
      let id = evt.uid;
      if (this.rtc.remoteStreams[id]) {
        this.$set(this.rtc.remoteStreams[id], "audio", true);
      }
    },
    muteVideo(evt) {
      let id = evt.uid;
      if (this.rtc.remoteStreams[id]) {
        this.$set(this.rtc.remoteStreams[id], "video", false);
      }
    },
    unmuteVideo(evt) {
      let id = evt.uid;
      if (this.rtc.remoteStreams[id]) {
        this.$set(this.rtc.remoteStreams[id], "video", true);
      }
    },
    peerLeave(evt) {
      let id = evt.uid;
      console.log("id", evt);
      // let streams = this.rtc.remoteStreams.filter(e => id !== e.getId());
      // let peerStream = this.rtc.remoteStreams.find(e => id === e.getId());
      // if (peerStream && peerStream.isPlaying()) {
      //   peerStream.stop();
      // }
      // this.$set(this.rtc, "remoteStreams", streams);
      if (
        this.rtc.remoteStreams[id] &&
        this.rtc.remoteStreams[id].stream &&
        this.rtc.remoteStreams[id].stream.isPlaying()
      ) {
        this.rtc.remoteStreams[id].stream.stop();
      }
      delete this.rtc.remoteStreams[id];
      this.$set(this.rtc, "remoteStreams", this.rtc.remoteStreams);
      console.log("peer-leave", id);
    },
    streamRemoved(evt) {
      let remoteStream = evt.stream;
      let id = remoteStream.getId();
      if (remoteStream.isPlaying()) {
        remoteStream.stop();
      }
      // let remoteStreams = [...this.rtc.remoteStreams];
      // remoteStreams = remoteStreams.filter(stream => stream.getId() !== id);
      // this.$set(this.rtc, "remoteStreams", remoteStreams);
      delete this.rtc.remoteStreams[id];
      this.$set(this.rtc, "remoteStreams", this.rtc.remoteStreams);
      // removeView(id);
      console.log("stream-removed remote-uid: ", id);
    },
    streamSubscribed(evt) {
      let stream = evt.stream;
      let id = stream.getId();
      // let remoteStreams = [...this.rtc.remoteStreams];
      // remoteStreams.push(remoteStream);
      // this.$set(this.rtc, "remoteStreams", remoteStreams);
      let streamObj = { video: true, audio: true, stream };
      this.$set(this.rtc.remoteStreams, id, streamObj);
      this.$nextTick(() => stream.play(`remote_video_${id}`));
      console.log("stream-subscribed remote-uid: ", id);
    },
    streamAdded(evt) {
      let remoteStream = evt.stream;
      let id = remoteStream.getId();
      if (id !== this.user.id) {
        this.rtc.client.subscribe(remoteStream, err => {
          console.log("stream subscribe failed", err);
        });
      }
      console.log("stream-added remote-uid: ", id);
    },
    clientLeaveCallback() {
      // stop stream
      if (this.rtc.localStream.isPlaying()) {
        this.rtc.localStream.stop();
      }
      // close stream
      this.rtc.localStream.close();
      Object.keys(this.rtc.remoteStreams).forEach(key => {
        if (this.rtc.remoteStreams[key].stream.isPlaying()) {
          this.rtc.remoteStreams[key].stream.stop();
        }
      });
      this.rtc.localStream = null;
      this.rtc.remoteStreams = {};
      this.rtc.client = null;
      console.log("client leaves channel success");
      this.rtc.published = false;
      this.rtc.joined = false;
      alert("leave success");
    },
    leave() {
      const { rtc, clientLeaveCallback, handleFailCallback } = this;
      if (!rtc.client) {
        alert("Please Join First!");
        return;
      }
      if (!rtc.joined) {
        alert("You are not in channel");
        return;
      }
      rtc.client.leave(clientLeaveCallback, handleFailCallback);
    },
    muteLocalAudio() {
      this.rtc.params.audio = !this.rtc.params.audio;
      if (this.rtc.localStream == null) {
        return;
      }
      if (this.rtc.params.audio) {
        this.rtc.localStream.unmuteAudio();
      } else {
        this.rtc.localStream.muteAudio();
      }
    },
    muteLocalVideo() {
      this.rtc.params.video = !this.rtc.params.video;
      if (this.rtc.localStream == null) {
        return;
      }
      if (this.rtc.params.video) {
        this.rtc.localStream.unmuteVideo();
      } else {
        this.rtc.localStream.muteVideo();
      }
    },
    beautify() {
      if (this.rtc.localStream == null) {
        return;
      }
      this.rtc.localStream.setBeautyEffectOptions(true, {
        lighteningContrastLevel: 1,
        lighteningLevel: 0.7,
        smoothnessLevel: 0.5,
        rednessLevel: 0.1
      });
    }
  },
  mounted() {
    this.getDevices();
    this.getAgoraToken().then(
      // () => this.join()
      console.log("token gotten")
    );
  }
};
